"use client";
import { TabNavigationProps } from "./types";

export const TabNavigation = ({
  activeTab,
  onTabChange,
}: TabNavigationProps) => {
  const tabs = [
    { id: "description" as const, label: "Description" },
    { id: "additional" as const, label: "Additional Information" },
    { id: "reviews" as const, label: "Reviews" }
  ];
  return (
    <div className="flex border-b border-gray-200">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`flex-1 py-3 px-4 text-sm font-medium transition-colors duration-200 ${
            activeTab === tab.id
              ? "text-black border-b-2 border-black"
              : "text-gray-600 hover:text-gray-800"
          }`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
